import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StepComponent } from '../../../classes/abstract-step.component';
import { IStepCheckbox } from '../../../interfaces/step-checkbox.interface';

@Component({
  standalone: false,
  selector: 'app-requirements-step',
  templateUrl: './requirements-step.component.html',
  styleUrls: ['../../../styles/step.styles.scss', './requirements-step.component.scss'],
})
export class RequirementsStepComponent extends StepComponent {
  @Input() readonly parentFormGroup: FormGroup;
  @Input() readonly controlName: string;

  readonly formGroup = new FormGroup({});

  readonly checkboxes: IStepCheckbox[] = [
    {
      name: 'monetiseData',
      label: 'To monetise my data.',
    },
    {
      name: 'analyseData',
      label: 'To analyse my data.',
    },
    {
      name: 'makeAPI',
      label: 'To create an API for my data.',
    },
    {
      name: 'reportsOrPresentation',
      label: 'To create reports or present my data.',
    },
  ];
}
